import React, { useState, useEffect } from 'react';

import GenericEditable from './shared/GenericEditable';
import DisplayOwner from './owner/DisplayOwner';
import EditItem from './item/EditItem';

import { createGetSuggestionsFromApiUrl } from './HelpMethods';
import { useTranslation } from 'react-i18next';
import { FILTER_ITEM_CHANGE_OWNER } from '../../../../i18n/keyConstants';

/**
 * Owner editable in popup after click.
 * `User`:
 *  - `{string id, string name, string link, string detailedName}`.
 * @param {string} [initialValue] Initial field value.
 * @param {function} [handleSave] [async user=>{bool success, string message}] Save changes / return error message.
 */
const EditableOwner = ({ initialValue: onPageLoadValue, handleSave: syncChanges, updateStore }) => {
    const [user, setUser] = useState(onPageLoadValue);
    const [initialUser, setInitialUser] = useState(onPageLoadValue);
    const { t } = useTranslation(['dealFilterDropDown']);
    const description = t(FILTER_ITEM_CHANGE_OWNER);
    const getSuggestions = createGetSuggestionsFromApiUrl('api/crmUserFront/getUserSuggestions');

    useEffect(() => {
        setUser(onPageLoadValue);
        setInitialUser(onPageLoadValue);
    }, [onPageLoadValue]);

    const valueHasntChanged = () => {
        if (user === null || initialUser === null) {
            return user === initialUser;
        }
        return user.id === initialUser.id;
    };

    const handleSave = async () => {
        if (!user || !user.id) {
            return { success: false, message: 'Får inte vara tomt.' };
        }
        const response = await syncChanges(user);
        if (response.success) {
            if (response.deal) {
                updateStore(response.deal);
            }
            if (response.organization) {
                updateStore(response.organization);
            }
            if (response.person) {
                updateStore(response.person);
            }
            setInitialUser(user);
        }
        return response;
    };

    const handleCancel = () => {
        setUser(initialUser);
    };

    let OwnerComponent;
    if (initialUser) {
        OwnerComponent = <DisplayOwner {...{ item: initialUser }} />;
    }

    return (
        <div className='editable-owner-wrapper'>
            {OwnerComponent}
            <GenericEditable {...{ handleSave, handleCancel, description, valueHasntChanged }}>
                <div className='edit-button oi oi-chevron-bottom' />
                <EditItem
                    {...{
                        iconName: 'user',
                        value: user,
                        setValue: setUser,
                        getSuggestions,
                    }}
                />
            </GenericEditable>
        </div>
    );
};

export default EditableOwner;
